/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Sign_No_Methods_DescriptionInputs */

const en_common_sign_no_methods_description = /** @type {(inputs: Common_Sign_No_Methods_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The administrator hasn't enabled any sign-in methods yet. Please check back later.`)
};

const zh_common_sign_no_methods_description = /** @type {(inputs: Common_Sign_No_Methods_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`管理员尚未启用任何登录方式，请稍后再试。`)
};

/**
* | output |
* | --- |
* | "The administrator hasn't enabled any sign-in methods yet. Please check back later." |
*
* @param {Common_Sign_No_Methods_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_sign_no_methods_description = /** @type {((inputs?: Common_Sign_No_Methods_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Sign_No_Methods_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_sign_no_methods_description(inputs)
	return zh_common_sign_no_methods_description(inputs)
});
export { common_sign_no_methods_description as "common.sign.no_methods_description" }